import {
  ASSIGNED_VS_RESOLVED,
  AVERAGE_FIRST_RESPONSE_USERS,
  AVERAGE_REPLIES_RESOLUTION_USERS,
  AVERAGE_RESOLUTION_USERS,
  AVERAGE_RESOLVED_TIME_USERS,
  FIRST_RESPONSE_USERS,
  STATUS_ACROSS_TIME_USERS,
  TOTAL_ASSIGNED,
  TOTAL_RESOLVED,
} from 'actions/types'

export default function (state = {}, action) {
  switch (action.type) {
    case TOTAL_RESOLVED:
      return {
        ...state,
        totalResolvedData: action.payload,
      }
    case TOTAL_ASSIGNED:
      return {
        ...state,
        totalAssignedData: action.payload,
      }
    case FIRST_RESPONSE_USERS:
      return {
        ...state,
        firstResponseUsersData: action.payload,
      }
    case AVERAGE_RESOLUTION_USERS:
      return {
        ...state,
        averageResolutionUsersData: action.payload,
      }
    case ASSIGNED_VS_RESOLVED:
      return {
        ...state,
        assignedVsResolvedData: action.payload,
      }
    case STATUS_ACROSS_TIME_USERS:
      return {
        ...state,
        statusAcrossTimesUsersData: action.payload,
      }

    case AVERAGE_FIRST_RESPONSE_USERS:
      return {
        ...state,
        averageFirstResponseUsersData: action.payload,
      }
    case AVERAGE_RESOLVED_TIME_USERS:
      return {
        ...state,
        averageResolvedTimeUsersData: action.payload,
      }
    case AVERAGE_REPLIES_RESOLUTION_USERS:
      return {
        ...state,
        averageRepliesResolutionUsersData: action.payload,
      }

    default:
      return state
  }
}
